module.exports = __webpack_public_path__ + "img/import-portfolio-light.a128575.svg";